import {EventBus} from '../lib/event-bus'

export default {
    data() {
        return {
            prevent_from_closing: false,
        }
    },

    created() {
        EventBus.$on('prevent-from-closing', (val) => {
            this.prevent_from_closing = val;

            if(val === true) {
                setTimeout(() => {
                    this.prevent_from_closing = false;
                }, 100);
            }
        });
    }
}